export default __webpack_public_path__ + "static/media/secours.ed3eb0f4.svg";